import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { Observable } from 'rxjs';

import { Bill } from '../models/Bill';

import { CURRENT_BILL } from '../mock-data/mock-data';


@Injectable()
export class CurrentBillService {

  constructor(private http: HttpClient) { }

  getCurrentBill(): Bill {
    return CURRENT_BILL;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/current-bill.service.ts